import styled from 'styled-components';
import { detectOS } from 'detect-browser';
import { colors } from '../ui-elements/Main/MainTheme';

export const DateTimeInput = styled.input<{
  isMobile?: boolean;
  compact?: boolean;
}>`
  border: 1px solid ${colors.inactiveGray};
  width: 100%;
  padding: ${({ $compact }) => $compact ? '6px 8px' : '15px'};
  border-radius: ${({ $compact }) => $compact ? '8px' : '10px'};
  font-family: Montserrat, sans-serif;
  font-weight: ${({ $compact }) => $compact ? '500' : '800'} !important;
  font-size: ${({ $compact }) => $compact ? '13px' : '14px'};
  background: ${colors.white};
  color: ${colors.black};
  min-height: ${({ $compact }) => $compact ? 'auto' : '55px'};
  margin-bottom: ${({ $compact }) => $compact ? '0' : '15px'};
  outline: none;
  &:focus {
    border-color: ${colors.orange};
  }
  ${({ $isMobile }) => ($isMobile && `
    min-width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 45px;
    ::-webkit-date-and-time-value {
      text-align: left;
      padding: 17px;
      min-height: 17px;
    }
  `)}
  ${() => detectOS(window.navigator.userAgent) === 'iOS' && `
    &::before {
      content: attr(placeholder);
      width: 100%;
    }
  `}
  ${() => detectOS(window.navigator.userAgent) === 'Android OS' && `
    &::before {
      content: attr(placeholder);
      width: 100%;
    }
  `}
`;
